import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SubTitle, ItemList } from 'components';
import './FundItemList.scss';

const FundItemList = ({ title, data }) => (
  <div className="nw-page-fundfactsheet__top-holdings">
    <SubTitle title={(<FormattedMessage id={title} />)} />
    <ItemList data={data} />
  </div>
);

export default FundItemList;
